import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import OtaService from "common/services/ota/OtaService";

/** Async Thunks */
export const fetchListOta = createAsyncThunk("ota/fetchListOta", async () => {
  try {
    const response = await OtaService.getAll();
    return response.data;
  } catch (error) {
    if (error.response.status === 404) {
      return [];
    }
    console.log("Error fetching ota list: ", error);
    throw error;
  }
});

/** Initial State */

const initialState = {
  items: [],
  loading: {
    otas: true,
  },
  form: {
    devicesSelection: "specific",
    selection: [],
    gatewayIds: [],
    uploadedFile: null,
    targetDefinition: "",
    version:""
  }
};

/** Slice */

export const otaSlice = createSlice({
  name: "ota",
  initialState,
  reducers: {
    changeSelectionMode: (state, action) => {
      state.form.devicesSelection = action.payload;
    },
    setGatewayIds: (state, action) => {
      state.form.selection = action.payload;
      state.form.gatewayIds = action.payload.map(item => item.id);
    },
    setUploadedFile: (state, action) => {
      state.form.uploadedFile = action.payload;
    },
    setTargetDefinition: (state, action) => {
      state.form.targetDefinition = action.payload;
    },
    setVersion: (state, action) => {
      state.form.version = action.payload;
    },
    clearUploadedFile: (state) => {
      state.form.uploadedFile = null;
    },
    resetState: (state) => {
      state.form.devicesSelection = "specific";
      state.form.uploadedFile = null;
      state.form.targetDefinition = "";
      state.form.version = "";
    },
    deviceOtaReceived: (state, action) => {

      // Extract data from the action payload
      const { gatewayId, timeStart, body } = action.payload;

      // TODO Possibility to insert a control on the user level

      // Find the index of the item in the 'items' array using its id
      const items = state.items
      const index = items.findIndex(item => item.gatewayId === body.gatewayId && item.timeStart === parseInt(body.timeStart));

      // If the item is found, update the OTA status
      if (index !== -1 && body && body.otaStatus) {
        state.items[index] = {
          ...state.items[index],
          // Update the OTA status or other necessary properties
          otaStatus: body.otaStatus,
          timeEnd: parseInt(body.timeEnd),
          updateDevice: body.updateDevice
        };
      }
    },
  },    
  extraReducers: builder => {
    builder.addCase(fetchListOta.pending, (state, action) => {
      state.loading.otas = true;
    });
    builder.addCase(fetchListOta.fulfilled, (state, action) => {
      state.items = action.payload;
      state.loading.otas = false;
    });
    builder.addCase(fetchListOta.rejected, (state, action) => {
      state.loading.otas = false;
    });
  },
});

export const { changeSelectionMode, setGatewayIds, setUploadedFile, setTargetDefinition, setVersion, clearUploadedFile, resetState, deviceOtaReceived } = otaSlice.actions;
export default otaSlice.reducer;